import Flicking from '@egjs/react-flicking'
import { useField } from 'formik'
import React from 'react'

const FormRadioButtonGroup = ({ handle, options }) => {
  const [{ value }, , { setValue }] = useField(handle)

  return (
    <div className="flex items-center mb-8">
      <Flicking autoInit align="prev">
        {options.map((option, index) => (
          <button
            type="button"
            key={option.value}
            className={`inline-flex whitespace-nowrap items-center text-sm justify-center px-3 border-t border-r border-b h-11 border-gray-5 focus:outline-none ${
              value === option.value && 'bg-gray-5 text-white'
            } ${index === 0 && 'border-l rounded-tl rounded-bl'} ${
              index === options.length - 1 && 'rounded-tr rounded-br'
            }`}
            onClick={() => setValue(option.value)}
          >
            {option.label}
          </button>
        ))}
      </Flicking>
    </div>
  )
}

export default FormRadioButtonGroup
